export function fetchAsync(url, headers, successCallback, failureCallback) {
  let customHeaders = headers;
  if (!customHeaders) {
    customHeaders = {};
  }
  customHeaders["Content-Type"] = "application/json";
  fetch(url, { headers: customHeaders })
    .then(handleErrors(failureCallback))
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        response
          .json()
          .then((data) => successCallback && successCallback(data));
      } else {
        const text = "Unexpected content-type: " + JSON.stringify(contentType);
        failureCallback &&
          failureCallback({
            message: text,
            status: 400,
          });
        throw Error(text);
      }
    })
    .catch((error) => console.error(error));
}

function handleErrors(failureCallback) {
  return (response) => {
    if (!response.ok) {
      response.text().then(
        (text) =>
          failureCallback &&
          failureCallback({
            message: text,
            status: response.status,
          })
      );
      throw Error("Server responded with " + response.status);
    }
    return response;
  };
}

export function hasFunction(obj, funcName) {
  return obj && funcName in obj && typeof obj[funcName] === "function";
}

export function obtainFunctionResult(obj, funcName, value) {
  if (hasFunction(obj, funcName)) {
    try {
      return obj[funcName](value);
    } catch (ex) {
      console.error("Error calling function '%s': %o", funcName, ex);
      return null;
    }
  } else {
    return null;
  }
}
